import CustomerIoIcon from '@/assets/icons/CustomerIoIcon';
import StripeIcon from '@/assets/icons/StripeIcon';
import ToltIcon from '@/assets/icons/ToltIcon';
import { ReactNode } from 'react';

export const PROVIDER_LOGOS: Record<string, ReactNode> = {
  tolt: <ToltIcon />,
  stripe: <StripeIcon />,
  customer_io: <CustomerIoIcon />
};

export function getProviderLogo(provider: string): ReactNode {
  return PROVIDER_LOGOS[provider] ?? null;
}
